// /* eslint-disable react/jsx-no-bind */
// import React, { useState, useEffect } from 'react';
// import { Container, Typography, Box, Tabs, Tab, Button, Stack } from '@mui/material';
// import { Helmet } from 'react-helmet-async';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { Url } from '../url/url';

// function TabPanel({ children, value, index }) {
//   return value === index ? <Box sx={{ pt: 3 }}>{children}</Box> : null;
// }

// function Field({ label, required, children }) {
//   return (
//     <div className="mb-3">
//       <p className="mb-1 fw-bold" style={{ fontSize: 14 }}>
//         {label} {required && <span className="text-danger">*</span>}
//       </p>
//       {children}
//     </div>
//   );
// }

// function Card({ title, children, onSubmit, loading }) {
//   return (
//     <div className="bg-white rounded-3 shadow-sm border p-4 mb-4">
//       {title && <h6 className="fw-bold text-primary mb-3 pb-2 border-bottom">{title}</h6>}
//       <form onSubmit={onSubmit}>
//         {children}
//         <div className="text-end mt-3">
//           <Button type="submit" variant="contained" disabled={loading} size="small">
//             {loading ? 'Saving...' : 'Save Changes'}
//           </Button>
//         </div>
//       </form>
//     </div>
//   );
// }

// const Settings = () => {
//   const [activeTab, setActiveTab]   = useState(0);
//   const [loading, setLoading]       = useState(false);
//   const [fetching, setFetching]     = useState(true);

//   // ── State ──────────────────────────────────────────────────────────────────
//   const [logoFile, setLogoFile]         = useState(null);
//   const [logoPreview, setLogoPreview]   = useState('');
//   const [currentLogo, setCurrentLogo]   = useState('');

//   const [company, setCompany] = useState({
//     name: '', email: '', phone: '', address: '', city: '', pincode: '', country: 'India',
//   });

//   const [contact, setContact] = useState({
//     supportEmail: '', supportPhone: '', whatsapp: '', businessHours: '',
//   });

//   const [banners, setBanners] = useState([
//     { title: '', subtitle: '', link: '', image: null, imagePreview: '', existingImage: '' }
//   ]);

//   const [socials, setSocials] = useState({
//     facebook: '', instagram: '', twitter: '', youtube: '', linkedin: '', pinterest: '',
//   });

//   // ── ✅ Fetch existing settings on mount ────────────────────────────────────
//   useEffect(() => {
//     async function fetchSettings() {
//       try {
//         const res = await axios.get(`${Url}/settings`);
//         const d   = res.data.data;

//         if (d.logo)     setCurrentLogo(d.logo);
//         if (d.company)  setCompany(prev => ({ ...prev, ...d.company }));
//         if (d.contact)  setContact(prev => ({ ...prev, ...d.contact }));
//         if (d.socials)  setSocials(prev => ({ ...prev, ...d.socials }));
//         if (d.banners && d.banners.length > 0) {
//           setBanners(
//             d.banners.map(b => ({
//               title:         b.title    || '',
//               subtitle:      b.subtitle || '',
//               link:          b.link     || '',
//               image:         null,
//               imagePreview:  '',
//               existingImage: b.image    || '',
//             }))
//           );
//         }
//       } catch (err) {
//         console.error('Settings fetch error:', err);
//       } finally {
//         setFetching(false);
//       }
//     }
//     fetchSettings();
//   }, []);

//   // ── Handlers ───────────────────────────────────────────────────────────────

//   function handleLogoChange(e) {
//     const file = e.target.files[0];
//     if (file) {
//       setLogoFile(file);
//       setLogoPreview(URL.createObjectURL(file));
//     }
//   }

//   async function submitLogo(e) {
//     e.preventDefault();
//     if (!logoFile) { Swal.fire('Please select a logo image'); return; }
//     setLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append('logo', logoFile);
//       const res = await axios.post(`${Url}/settings/logo`, formData);
//       setCurrentLogo(res.data.data.logo);
//       Swal.fire({ position: 'top-end', icon: 'success', title: 'Logo saved!', showConfirmButton: false, timer: 1500 });
//     } catch {
//       Swal.fire({ icon: 'error', title: 'Something went wrong' });
//     } finally { setLoading(false); }
//   }

//   async function submitCompany(e) {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       await axios.post(`${Url}/settings/company`, company);
//       Swal.fire({ position: 'top-end', icon: 'success', title: 'Company info saved!', showConfirmButton: false, timer: 1500 });
//     } catch {
//       Swal.fire({ icon: 'error', title: 'Something went wrong' });
//     } finally { setLoading(false); }
//   }

//   async function submitContact(e) {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       await axios.post(`${Url}/settings/contact`, contact);
//       Swal.fire({ position: 'top-end', icon: 'success', title: 'Contact info saved!', showConfirmButton: false, timer: 1500 });
//     } catch {
//       Swal.fire({ icon: 'error', title: 'Something went wrong' });
//     } finally { setLoading(false); }
//   }

//   function handleBannerChange(index, field, value) {
//     setBanners(prev => prev.map((b, i) => i === index ? { ...b, [field]: value } : b));
//   }

//   function handleBannerImage(index, e) {
//     const file = e.target.files[0];
//     if (file) {
//       setBanners(prev => prev.map((b, i) =>
//         i === index ? { ...b, image: file, imagePreview: URL.createObjectURL(file) } : b
//       ));
//     }
//   }

//   function addBanner() {
//     setBanners(prev => [...prev, { title: '', subtitle: '', link: '', image: null, imagePreview: '', existingImage: '' }]);
//   }

//   function removeBanner(index) {
//     setBanners(prev => prev.filter((_, i) => i !== index));
//   }

//   async function submitBanners(e) {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const formData = new FormData();
//       banners.forEach((b, i) => {
//         formData.append(`banners[${i}][title]`,         b.title         || '');
//         formData.append(`banners[${i}][subtitle]`,      b.subtitle      || '');
//         formData.append(`banners[${i}][link]`,          b.link          || '');
//         formData.append(`banners[${i}][existingImage]`, b.existingImage || '');
//         if (b.image) formData.append('bannerImages', b.image);
//       });
//       await axios.post(`${Url}/settings/banners`, formData);
//       Swal.fire({ position: 'top-end', icon: 'success', title: 'Banners saved!', showConfirmButton: false, timer: 1500 });
//     } catch {
//       Swal.fire({ icon: 'error', title: 'Something went wrong' });
//     } finally { setLoading(false); }
//   }

//   async function submitSocials(e) {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       await axios.post(`${Url}/settings/socials`, socials);
//       Swal.fire({ position: 'top-end', icon: 'success', title: 'Social links saved!', showConfirmButton: false, timer: 1500 });
//     } catch {
//       Swal.fire({ icon: 'error', title: 'Something went wrong' });
//     } finally { setLoading(false); }
//   }

//   const socialFields = [
//     { key: 'facebook',  label: 'Facebook',    icon: 'fa-facebook',  color: '#1877F2', placeholder: 'https://facebook.com/yourpage' },
//     { key: 'instagram', label: 'Instagram',   icon: 'fa-instagram', color: '#E4405F', placeholder: 'https://instagram.com/yourhandle' },
//     { key: 'twitter',   label: 'Twitter / X', icon: 'fa-x-twitter', color: '#000000', placeholder: 'https://x.com/yourhandle' },
//     { key: 'youtube',   label: 'YouTube',     icon: 'fa-youtube',   color: '#FF0000', placeholder: 'https://youtube.com/yourchannel' },
//     { key: 'linkedin',  label: 'LinkedIn',    icon: 'fa-linkedin',  color: '#0A66C2', placeholder: 'https://linkedin.com/company/yourco' },
//     { key: 'pinterest', label: 'Pinterest',   icon: 'fa-pinterest', color: '#E60023', placeholder: 'https://pinterest.com/yourprofile' },
//   ];

//   // ── Loading skeleton ───────────────────────────────────────────────────────
//   if (fetching) {
//     return (
//       <Container>
//         <div className="text-center py-5 text-muted">
//           <div className="spinner-border spinner-border-sm me-2" />
//           Loading settings...
//         </div>
//       </Container>
//     );
//   }

//   // ── JSX ────────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <Helmet><title>Dashboard: Settings | Doozie-do</title></Helmet>

//       <Container>
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
//           <Typography variant="h4" gutterBottom>Settings</Typography>
//         </Stack>
//       </Container>

//       <Container>
//         <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}>
//           <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} variant="scrollable" scrollButtons="auto">
//             <Tab label="Company Logo" />
//             <Tab label="Company Info" />
//             <Tab label="Contact" />
//             <Tab label="Home Banner" />
//             <Tab label="Social Links" />
//           </Tabs>
//         </Box>

//         {/* ── TAB 0: Logo ─────────────────────────────────────────── */}
//         <TabPanel value={activeTab} index={0}>
//           <Card title="Company Logo" onSubmit={submitLogo} loading={loading}>
//             {/* ✅ Current saved logo */}
//             {currentLogo && !logoPreview && (
//               <div className="mb-3">
//                 <p className="mb-1 fw-bold" style={{ fontSize: 13 }}>Current Logo:</p>
//                 <div className="border rounded-3 p-3 d-inline-block bg-light">
//                   <img src={currentLogo} alt="Current logo" style={{ maxHeight: 80, maxWidth: 260, objectFit: 'contain' }} />
//                 </div>
//               </div>
//             )}
//             <Field label="Upload New Logo" required>
//               <input type="file" accept="image/*" onChange={handleLogoChange} className="form-control" />
//               <small className="text-muted">Recommended: PNG with transparent background, min 200×200px</small>
//             </Field>
//             {logoPreview && (
//               <div className="mt-2">
//                 <p className="mb-1 fw-bold" style={{ fontSize: 13 }}>New Preview:</p>
//                 <div className="border rounded-3 p-3 d-inline-block bg-light">
//                   <img src={logoPreview} alt="Logo preview" style={{ maxHeight: 100, maxWidth: 300, objectFit: 'contain' }} />
//                 </div>
//               </div>
//             )}
//           </Card>
//         </TabPanel>

//         {/* ── TAB 1: Company Info ─────────────────────────────────── */}
//         <TabPanel value={activeTab} index={1}>
//           <Card title="Company Information" onSubmit={submitCompany} loading={loading}>
//             <div className="row g-3">
//               <div className="col-md-6">
//                 <Field label="Company Name" required>
//                   <input className="form-control" value={company.name} onChange={e => setCompany(p => ({ ...p, name: e.target.value }))} placeholder="Doozie-do" required />
//                 </Field>
//               </div>
//               <div className="col-md-6">
//                 <Field label="Business Email" required>
//                   <input type="email" className="form-control" value={company.email} onChange={e => setCompany(p => ({ ...p, email: e.target.value }))} placeholder="hello@dooziedo.com" required />
//                 </Field>
//               </div>
//               <div className="col-md-6">
//                 <Field label="Phone Number">
//                   <input type="tel" className="form-control" value={company.phone} onChange={e => setCompany(p => ({ ...p, phone: e.target.value }))} placeholder="+91 98765 43210" />
//                 </Field>
//               </div>
//               <div className="col-md-6">
//                 <Field label="City">
//                   <input className="form-control" value={company.city} onChange={e => setCompany(p => ({ ...p, city: e.target.value }))} placeholder="Mumbai" />
//                 </Field>
//               </div>
//               <div className="col-12">
//                 <Field label="Address">
//                   <textarea className="form-control" rows={2} value={company.address} onChange={e => setCompany(p => ({ ...p, address: e.target.value }))} placeholder="Street, Area, Landmark..." />
//                 </Field>
//               </div>
//               <div className="col-md-6">
//                 <Field label="Pincode">
//                   <input className="form-control" value={company.pincode} onChange={e => setCompany(p => ({ ...p, pincode: e.target.value }))} placeholder="400001" />
//                 </Field>
//               </div>
//               <div className="col-md-6">
//                 <Field label="Country">
//                   <input className="form-control" value={company.country} onChange={e => setCompany(p => ({ ...p, country: e.target.value }))} placeholder="India" />
//                 </Field>
//               </div>
//             </div>
//           </Card>
//         </TabPanel>

//         {/* ── TAB 2: Contact ──────────────────────────────────────── */}
//         <TabPanel value={activeTab} index={2}>
//           <Card title="Contact Details" onSubmit={submitContact} loading={loading}>
//             <div className="row g-3">
//               <div className="col-md-6">
//                 <Field label="Support Email" required>
//                   <input type="email" className="form-control" value={contact.supportEmail} onChange={e => setContact(p => ({ ...p, supportEmail: e.target.value }))} placeholder="support@dooziedo.com" required />
//                 </Field>
//               </div>
//               <div className="col-md-6">
//                 <Field label="Support Phone">
//                   <input type="tel" className="form-control" value={contact.supportPhone} onChange={e => setContact(p => ({ ...p, supportPhone: e.target.value }))} placeholder="+91 98765 43210" />
//                 </Field>
//               </div>
//               <div className="col-md-6">
//                 <Field label="WhatsApp Number">
//                   <div className="input-group">
//                     <span className="input-group-text" style={{ background: '#25D366', color: '#fff', border: 'none' }}>
//                       <i className="fa-brands fa-whatsapp" />
//                     </span>
//                     <input type="tel" className="form-control" value={contact.whatsapp} onChange={e => setContact(p => ({ ...p, whatsapp: e.target.value }))} placeholder="+91 98765 43210" />
//                   </div>
//                 </Field>
//               </div>
//               <div className="col-md-6">
//                 <Field label="Business Hours">
//                   <input className="form-control" value={contact.businessHours} onChange={e => setContact(p => ({ ...p, businessHours: e.target.value }))} placeholder="Mon–Sat, 10am–6pm" />
//                 </Field>
//               </div>
//             </div>
//           </Card>
//         </TabPanel>

//         {/* ── TAB 3: Home Banner ──────────────────────────────────── */}
//         <TabPanel value={activeTab} index={3}>
//           <form onSubmit={submitBanners}>
//             {banners.map((banner, index) => (
//               <div key={index} className="bg-white rounded-3 shadow-sm border p-4 mb-3">
//                 <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
//                   <h6 className="fw-bold text-primary mb-0">Banner {index + 1}</h6>
//                   {banners.length > 1 && (
//                     <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => removeBanner(index)}>
//                       <i className="fa-solid fa-trash fa-sm me-1" /> Remove
//                     </button>
//                   )}
//                 </div>
//                 <div className="row g-3">
//                   <div className="col-md-6">
//                     <Field label="Banner Title">
//                       <input className="form-control" value={banner.title} onChange={e => handleBannerChange(index, 'title', e.target.value)} placeholder="e.g. New Arrivals" />
//                     </Field>
//                   </div>
//                   <div className="col-md-6">
//                     <Field label="Subtitle">
//                       <input className="form-control" value={banner.subtitle} onChange={e => handleBannerChange(index, 'subtitle', e.target.value)} placeholder="e.g. Shop the latest collection" />
//                     </Field>
//                   </div>
//                   <div className="col-md-6">
//                     <Field label="Link URL">
//                       <input className="form-control" value={banner.link} onChange={e => handleBannerChange(index, 'link', e.target.value)} placeholder="https://dooziedo.com/new-arrivals" />
//                     </Field>
//                   </div>
//                   <div className="col-md-6">
//                     <Field label="Banner Image">
//                       <input type="file" accept="image/*" className="form-control" onChange={e => handleBannerImage(index, e)} />
//                       <small className="text-muted">Recommended: 1920×600px</small>
//                     </Field>
//                   </div>

//                   {/* ✅ Existing saved image dikhao */}
//                   {banner.existingImage && !banner.imagePreview && (
//                     <div className="col-12">
//                       <p className="mb-1 fw-bold" style={{ fontSize: 13 }}>Current Image:</p>
//                       <img src={banner.existingImage} alt="" className="rounded-2 border" style={{ maxHeight: 120, maxWidth: '100%', objectFit: 'cover' }} />
//                     </div>
//                   )}

//                   {/* ✅ New selected image preview */}
//                   {banner.imagePreview && (
//                     <div className="col-12">
//                       <p className="mb-1 fw-bold" style={{ fontSize: 13 }}>New Preview:</p>
//                       <img src={banner.imagePreview} alt="" className="rounded-2 border" style={{ maxHeight: 140, maxWidth: '100%', objectFit: 'cover' }} />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))}

//             <div className="d-flex gap-2 justify-content-between align-items-center">
//               <button type="button" className="btn btn-outline-primary btn-sm" onClick={addBanner}>
//                 <i className="fa-solid fa-plus me-1" /> Add Another Banner
//               </button>
//               <Button type="submit" variant="contained" disabled={loading} size="small">
//                 {loading ? 'Saving...' : 'Save Banners'}
//               </Button>
//             </div>
//           </form>
//         </TabPanel>

//         {/* ── TAB 4: Social Links ─────────────────────────────────── */}
//         <TabPanel value={activeTab} index={4}>
//           <Card title="Social Media Links" onSubmit={submitSocials} loading={loading}>
//             <div className="row g-3">
//               {socialFields.map(({ key, label, icon, color, placeholder }) => (
//                 <div className="col-md-6" key={key}>
//                   <Field label={label}>
//                     <div className="input-group">
//                       <span className="input-group-text" style={{ background: color, color: '#fff', border: 'none', minWidth: 44 }}>
//                         <i className={`fa-brands ${icon}`} />
//                       </span>
//                       <input
//                         type="url"
//                         className="form-control"
//                         value={socials[key]}
//                         onChange={e => setSocials(p => ({ ...p, [key]: e.target.value }))}
//                         placeholder={placeholder}
//                       />
//                     </div>
//                   </Field>
//                 </div>
//               ))}
//             </div>

//             {Object.values(socials).some(v => v) && (
//               <div className="mt-3 pt-3 border-top">
//                 <p className="mb-2 fw-bold" style={{ fontSize: 13 }}>Preview:</p>
//                 <div className="d-flex gap-2 flex-wrap">
//                   {socialFields.map(({ key, icon, color, label }) =>
//                     socials[key] ? (
//                       <a key={key} href={socials[key]} target="_blank" rel="noreferrer"
//                         className="btn btn-sm d-flex align-items-center gap-1"
//                         style={{ background: color, color: '#fff', fontSize: 13 }}>
//                         <i className={`fa-brands ${icon}`} />
//                         {label}
//                       </a>
//                     ) : null
//                   )}
//                 </div>
//               </div>
//             )}
//           </Card>
//         </TabPanel>

//       </Container>
//     </>
//   );
// };

// export default Settings;










/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Tabs, Tab, Button, Stack } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Url } from '../url/url';

function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ pt: 3 }}>{children}</Box> : null;
}

function Field({ label, required, children }) {
  return (
    <div className="mb-3">
      <p className="mb-1 fw-bold" style={{ fontSize: 14 }}>
        {label} {required && <span className="text-danger">*</span>}
      </p>
      {children}
    </div>
  );
}

function Card({ title, children, onSubmit, loading }) {
  return (
    <div className="bg-white rounded-3 shadow-sm border p-4 mb-4">
      {title && <h6 className="fw-bold text-primary mb-3 pb-2 border-bottom">{title}</h6>}
      <form onSubmit={onSubmit}>
        {children}
        <div className="text-end mt-3">
          <Button type="submit" variant="contained" disabled={loading} size="small">
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
        </div>
      </form>
    </div>
  );
}

const Settings = () => {
  const [activeTab, setActiveTab]   = useState(0);
  const [loading, setLoading]       = useState(false);
  const [fetching, setFetching]     = useState(true);

  // ── State ──────────────────────────────────────────────────────────────────
  const [logoFile, setLogoFile]         = useState(null);
  const [logoPreview, setLogoPreview]   = useState('');
  const [currentLogo, setCurrentLogo]   = useState('');

  const [company, setCompany] = useState({
    name: '', email: '', phone: '', address: '', city: '', pincode: '', country: 'India',
  });

  const [contact, setContact] = useState({
    supportEmail: '', supportPhone: '', whatsapp: '', businessHours: '',
  });

  const [banners, setBanners] = useState([
    { title: '', subtitle: '', link: '', image: null, imagePreview: '', existingImage: '' }
  ]);

  const [socials, setSocials] = useState({
    facebook: '', instagram: '', twitter: '', youtube: '', linkedin: '', pinterest: '',
  });

  // ── ✅ Fetch existing settings on mount ────────────────────────────────────
  useEffect(() => {
    async function fetchSettings() {
      try {
        const res = await axios.get(`${Url}/settings`);
        const d   = res.data.data;

        if (d.logo)     setCurrentLogo(d.logo);
        if (d.company)  setCompany(prev => ({ ...prev, ...d.company }));
        if (d.contact)  setContact(prev => ({ ...prev, ...d.contact }));
        if (d.socials)  setSocials(prev => ({ ...prev, ...d.socials }));
        if (d.banners && d.banners.length > 0) {
          setBanners(
            d.banners.map(b => ({
              title:         b.title    || '',
              subtitle:      b.subtitle || '',
              link:          b.link     || '',
              image:         null,
              imagePreview:  '',
              existingImage: b.image    || '',
            }))
          );
        }
      } catch (err) {
        console.error('Settings fetch error:', err);
      } finally {
        setFetching(false);
      }
    }
    fetchSettings();
  }, []);

  // ── Handlers ───────────────────────────────────────────────────────────────

  function handleLogoChange(e) {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  }

  async function submitLogo(e) {
    e.preventDefault();
    if (!logoFile) { Swal.fire('Please select a logo image'); return; }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('logo', logoFile);
      const res = await axios.post(`${Url}/settings/logo`, formData);
      setCurrentLogo(res.data.data.logo);
      Swal.fire({ position: 'top-end', icon: 'success', title: 'Logo saved!', showConfirmButton: false, timer: 1500 });
    } catch {
      Swal.fire({ icon: 'error', title: 'Something went wrong' });
    } finally { setLoading(false); }
  }

  async function submitCompany(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${Url}/settings/company`, company);
      Swal.fire({ position: 'top-end', icon: 'success', title: 'Company info saved!', showConfirmButton: false, timer: 1500 });
    } catch {
      Swal.fire({ icon: 'error', title: 'Something went wrong' });
    } finally { setLoading(false); }
  }

  async function submitContact(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${Url}/settings/contact`, contact);
      Swal.fire({ position: 'top-end', icon: 'success', title: 'Contact info saved!', showConfirmButton: false, timer: 1500 });
    } catch {
      Swal.fire({ icon: 'error', title: 'Something went wrong' });
    } finally { setLoading(false); }
  }

  function handleBannerChange(index, field, value) {
    setBanners(prev => prev.map((b, i) => i === index ? { ...b, [field]: value } : b));
  }

  function handleBannerImage(index, e) {
    const file = e.target.files[0];
    if (file) {
      setBanners(prev => prev.map((b, i) =>
        i === index ? { ...b, image: file, imagePreview: URL.createObjectURL(file) } : b
      ));
    }
  }

  function addBanner() {
    setBanners(prev => [...prev, { title: '', subtitle: '', link: '', image: null, imagePreview: '', existingImage: '' }]);
  }

  function removeBanner(index) {
    setBanners(prev => prev.filter((_, i) => i !== index));
  }

  async function submitBanners(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      banners.forEach((b, i) => {
        // ✅ Flat keys — nested notation multer se parse nahi hoti reliably
        formData.append(`title_${i}`,         b.title         || '');
        formData.append(`subtitle_${i}`,      b.subtitle      || '');
        formData.append(`link_${i}`,          b.link          || '');
        formData.append(`existingImage_${i}`, b.existingImage || '');
        // ✅ Har banner ka apna unique field name — index mismatch kabhi nahi hoga
        if (b.image) formData.append(`bannerImage_${i}`, b.image);
      });
      await axios.post(`${Url}/settings/banners`, formData);
      Swal.fire({ position: 'top-end', icon: 'success', title: 'Banners saved!', showConfirmButton: false, timer: 1500 });
    } catch {
      Swal.fire({ icon: 'error', title: 'Something went wrong' });
    } finally { setLoading(false); }
  }

  async function submitSocials(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${Url}/settings/socials`, socials);
      Swal.fire({ position: 'top-end', icon: 'success', title: 'Social links saved!', showConfirmButton: false, timer: 1500 });
    } catch {
      Swal.fire({ icon: 'error', title: 'Something went wrong' });
    } finally { setLoading(false); }
  }

  const socialFields = [
    { key: 'facebook',  label: 'Facebook',    icon: 'fa-facebook',  color: '#1877F2', placeholder: 'https://facebook.com/yourpage' },
    { key: 'instagram', label: 'Instagram',   icon: 'fa-instagram', color: '#E4405F', placeholder: 'https://instagram.com/yourhandle' },
    { key: 'twitter',   label: 'Twitter / X', icon: 'fa-x-twitter', color: '#000000', placeholder: 'https://x.com/yourhandle' },
    { key: 'youtube',   label: 'YouTube',     icon: 'fa-youtube',   color: '#FF0000', placeholder: 'https://youtube.com/yourchannel' },
    { key: 'linkedin',  label: 'LinkedIn',    icon: 'fa-linkedin',  color: '#0A66C2', placeholder: 'https://linkedin.com/company/yourco' },
    { key: 'pinterest', label: 'Pinterest',   icon: 'fa-pinterest', color: '#E60023', placeholder: 'https://pinterest.com/yourprofile' },
  ];

  // ── Loading skeleton ───────────────────────────────────────────────────────
  if (fetching) {
    return (
      <Container>
        <div className="text-center py-5 text-muted">
          <div className="spinner-border spinner-border-sm me-2" />
          Loading settings...
        </div>
      </Container>
    );
  }

  // ── JSX ────────────────────────────────────────────────────────────────────
  return (
    <>
      <Helmet><title>Dashboard: Settings | Doozie-do</title></Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
          <Typography variant="h4" gutterBottom>Settings</Typography>
        </Stack>
      </Container>

      <Container>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}>
          <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} variant="scrollable" scrollButtons="auto">
            <Tab label="Company Logo" />
            <Tab label="Company Info" />
            <Tab label="Contact" />
            <Tab label="Home Banner" />
            <Tab label="Social Links" />
          </Tabs>
        </Box>

        {/* ── TAB 0: Logo ─────────────────────────────────────────── */}
        <TabPanel value={activeTab} index={0}>
          <Card title="Company Logo" onSubmit={submitLogo} loading={loading}>
            {/* ✅ Current saved logo */}
            {currentLogo && !logoPreview && (
              <div className="mb-3">
                <p className="mb-1 fw-bold" style={{ fontSize: 13 }}>Current Logo:</p>
                <div className="border rounded-3 p-3 d-inline-block bg-light">
                  <img src={currentLogo} alt="Current logo" style={{ maxHeight: 80, maxWidth: 260, objectFit: 'contain' }} />
                </div>
              </div>
            )}
            <Field label="Upload New Logo" required>
              <input type="file" accept="image/*" onChange={handleLogoChange} className="form-control" />
              <small className="text-muted">Recommended: PNG with transparent background, min 200×200px or use 204px X 40px</small>
            </Field>
            {logoPreview && (
              <div className="mt-2">
                <p className="mb-1 fw-bold" style={{ fontSize: 13 }}>New Preview:</p>
                <div className="border rounded-3 p-3 d-inline-block bg-light">
                  <img src={logoPreview} alt="Logo preview" style={{ maxHeight: 100, maxWidth: 300, objectFit: 'contain' }} />
                </div>
              </div>
            )}
          </Card>
        </TabPanel>

        {/* ── TAB 1: Company Info ─────────────────────────────────── */}
        <TabPanel value={activeTab} index={1}>
          <Card title="Company Information" onSubmit={submitCompany} loading={loading}>
            <div className="row g-3">
              <div className="col-md-6">
                <Field label="Company Name" required>
                  <input className="form-control" value={company.name} onChange={e => setCompany(p => ({ ...p, name: e.target.value }))} placeholder="Doozie-do" required />
                </Field>
              </div>
              <div className="col-md-6">
                <Field label="Business Email" required>
                  <input type="email" className="form-control" value={company.email} onChange={e => setCompany(p => ({ ...p, email: e.target.value }))} placeholder="hello@dooziedo.com" required />
                </Field>
              </div>
              <div className="col-md-6">
                <Field label="Phone Number">
                  <input type="tel" className="form-control" value={company.phone} onChange={e => setCompany(p => ({ ...p, phone: e.target.value }))} placeholder="+91 98765 43210" />
                </Field>
              </div>
              <div className="col-md-6">
                <Field label="City">
                  <input className="form-control" value={company.city} onChange={e => setCompany(p => ({ ...p, city: e.target.value }))} placeholder="Mumbai" />
                </Field>
              </div>
              <div className="col-12">
                <Field label="Address">
                  <textarea className="form-control" rows={2} value={company.address} onChange={e => setCompany(p => ({ ...p, address: e.target.value }))} placeholder="Street, Area, Landmark..." />
                </Field>
              </div>
              <div className="col-md-6">
                <Field label="Pincode">
                  <input className="form-control" value={company.pincode} onChange={e => setCompany(p => ({ ...p, pincode: e.target.value }))} placeholder="400001" />
                </Field>
              </div>
              <div className="col-md-6">
                <Field label="Country">
                  <input className="form-control" value={company.country} onChange={e => setCompany(p => ({ ...p, country: e.target.value }))} placeholder="India" />
                </Field>
              </div>
            </div>
          </Card>
        </TabPanel>

        {/* ── TAB 2: Contact ──────────────────────────────────────── */}
        <TabPanel value={activeTab} index={2}>
          <Card title="Contact Details" onSubmit={submitContact} loading={loading}>
            <div className="row g-3">
              <div className="col-md-6">
                <Field label="Support Email" required>
                  <input type="email" className="form-control" value={contact.supportEmail} onChange={e => setContact(p => ({ ...p, supportEmail: e.target.value }))} placeholder="support@dooziedo.com" required />
                </Field>
              </div>
              <div className="col-md-6">
                <Field label="Support Phone">
                  <input type="tel" className="form-control" value={contact.supportPhone} onChange={e => setContact(p => ({ ...p, supportPhone: e.target.value }))} placeholder="+91 98765 43210" />
                </Field>
              </div>
              <div className="col-md-6">
                <Field label="WhatsApp Number">
                  <div className="input-group">
                    <span className="input-group-text" style={{ background: '#25D366', color: '#fff', border: 'none' }}>
                      <i className="fa-brands fa-whatsapp" />
                    </span>
                    <input type="tel" className="form-control" value={contact.whatsapp} onChange={e => setContact(p => ({ ...p, whatsapp: e.target.value }))} placeholder="+91 98765 43210" />
                  </div>
                </Field>
              </div>
              <div className="col-md-6">
                <Field label="Business Hours">
                  <input className="form-control" value={contact.businessHours} onChange={e => setContact(p => ({ ...p, businessHours: e.target.value }))} placeholder="Mon–Sat, 10am–6pm" />
                </Field>
              </div>
            </div>
          </Card>
        </TabPanel>

        {/* ── TAB 3: Home Banner ──────────────────────────────────── */}
        <TabPanel value={activeTab} index={3}>
          <form onSubmit={submitBanners}>
            {banners.map((banner, index) => (
              <div key={index} className="bg-white rounded-3 shadow-sm border p-4 mb-3">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <h6 className="fw-bold text-primary mb-0">Banner {index + 1}</h6>
                  {banners.length > 1 && (
                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => removeBanner(index)}>
                      <i className="fa-solid fa-trash fa-sm me-1" /> Remove
                    </button>
                  )}
                </div>
                <div className="row g-3">
                  <div className="col-md-6">
                    <Field label="Banner Title">
                      <input className="form-control" value={banner.title} onChange={e => handleBannerChange(index, 'title', e.target.value)} placeholder="e.g. New Arrivals" />
                    </Field>
                  </div>
                  <div className="col-md-6">
                    <Field label="Subtitle">
                      <input className="form-control" value={banner.subtitle} onChange={e => handleBannerChange(index, 'subtitle', e.target.value)} placeholder="e.g. Shop the latest collection" />
                    </Field>
                  </div>
                  <div className="col-md-6">
                    <Field label="Link URL">
                      <input className="form-control" value={banner.link} onChange={e => handleBannerChange(index, 'link', e.target.value)} placeholder="https://dooziedo.com/new-arrivals" />
                    </Field>
                  </div>
                  <div className="col-md-6">
                    <Field label="Banner Image">
                      <input type="file" accept="image/*" className="form-control" onChange={e => handleBannerImage(index, e)} />
                      <small className="text-muted">Recommended: 1920×600px</small>
                    </Field>
                  </div>

                  {/* ✅ Existing saved image dikhao */}
                  {banner.existingImage && !banner.imagePreview && (
                    <div className="col-12">
                      <p className="mb-1 fw-bold" style={{ fontSize: 13 }}>Current Image:</p>
                      <img src={banner.existingImage} alt="" className="rounded-2 border" style={{ maxHeight: 120, maxWidth: '100%', objectFit: 'cover' }} />
                    </div>
                  )}

                  {/* ✅ New selected image preview */}
                  {banner.imagePreview && (
                    <div className="col-12">
                      <p className="mb-1 fw-bold" style={{ fontSize: 13 }}>New Preview:</p>
                      <img src={banner.imagePreview} alt="" className="rounded-2 border" style={{ maxHeight: 140, maxWidth: '100%', objectFit: 'cover' }} />
                    </div>
                  )}
                </div>
              </div>
            ))}

            <div className="d-flex gap-2 justify-content-between align-items-center">
              <button type="button" className="btn btn-outline-primary btn-sm" onClick={addBanner}>
                <i className="fa-solid fa-plus me-1" /> Add Another Banner
              </button>
              <Button type="submit" variant="contained" disabled={loading} size="small">
                {loading ? 'Saving...' : 'Save Banners'}
              </Button>
            </div>
          </form>
        </TabPanel>

        {/* ── TAB 4: Social Links ─────────────────────────────────── */}
        <TabPanel value={activeTab} index={4}>
          <Card title="Social Media Links" onSubmit={submitSocials} loading={loading}>
            <div className="row g-3">
              {socialFields.map(({ key, label, icon, color, placeholder }) => (
                <div className="col-md-6" key={key}>
                  <Field label={label}>
                    <div className="input-group">
                      <span className="input-group-text" style={{ background: color, color: '#fff', border: 'none', minWidth: 44 }}>
                        <i className={`fa-brands ${icon}`} />
                      </span>
                      <input
                        type="url"
                        className="form-control"
                        value={socials[key]}
                        onChange={e => setSocials(p => ({ ...p, [key]: e.target.value }))}
                        placeholder={placeholder}
                      />
                    </div>
                  </Field>
                </div>
              ))}
            </div>

            {Object.values(socials).some(v => v) && (
              <div className="mt-3 pt-3 border-top">
                <p className="mb-2 fw-bold" style={{ fontSize: 13 }}>Preview:</p>
                <div className="d-flex gap-2 flex-wrap">
                  {socialFields.map(({ key, icon, color, label }) =>
                    socials[key] ? (
                      <a key={key} href={socials[key]} target="_blank" rel="noreferrer"
                        className="btn btn-sm d-flex align-items-center gap-1"
                        style={{ background: color, color: '#fff', fontSize: 13 }}>
                        <i className={`fa-brands ${icon}`} />
                        {label}
                      </a>
                    ) : null
                  )}
                </div>
              </div>
            )}
          </Card>
        </TabPanel>

      </Container>
    </>
  );
};

export default Settings;